import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ClientConfigService } from "@app/core/config/client-config.service";
import { firstValueFrom } from "rxjs";

export interface RecallResponse {
  id: number;
  status: string;
  requestedBy: string;
  requestedTime: string;
  transactionGuid: string;
  timeoutMinutes: number;
  ticket: {
    id: number;
  };
}

@Injectable({
  providedIn: "root"
})
export class TicketRecallService {
  private clientConfigService = inject(ClientConfigService);
  private http = inject(HttpClient);

  public async initiateRecall(ticketId: number): Promise<RecallResponse> {
    const config = this.clientConfigService.config;
    const result = await firstValueFrom(
      this.http.post(
        config.serviceUrl + "/api/v1/recall/ticket/" + ticketId,
        {},
        { withCredentials: true }
      )
    );
    return result as RecallResponse;
  }

  public async cancelRecall(recallId: number): Promise<RecallResponse> {
    const config = this.clientConfigService.config;
    const result = await firstValueFrom(
      this.http.post(
        config.serviceUrl + "/api/v1/recall/" + recallId + "/cancel",
        {},
        { withCredentials: true }
      )
    );
    return result as RecallResponse;
  }

  public async getActiveRecalls(): Promise<RecallResponse[]> {
    const config = this.clientConfigService.config;
    const result = await firstValueFrom(
      this.http.get(config.serviceUrl + "/api/v1/recall/active", {
        withCredentials: true
      })
    );
    return result as RecallResponse[];
  }
}
